import { useLocation } from 'react-router-dom';
import { LifeGenericResult2 } from '../../components';
import { useTranslation } from 'react-i18next';

export const ChangeRequestError = () => {
  const { t } = useTranslation();
  const location = useLocation() as {
    state: {
      defaultTo?: string;
      defaultLabel?: string;
    };
  };
  return (
    <LifeGenericResult2
      title={t('common.requestLoadError')}
      defaultTo={location?.state?.defaultTo}
      defaultLabel={location?.state?.defaultLabel}
    />
  );
};
